<mng-file-drop style="height: 100%" (fileDropped)="onFileDropped($event)" (click)="selectFileInput()">
  <div id="file-select-div" fxLayout="row" fxLayoutAlign="center center" style="height: 100%">
    <div>
      @if (!multiple) {
        <input style="display: none" type="file" [id]="elementId" [name]="elementId" [accept]="accept" />
      }
      @if (multiple) {
        <input style="display: none" type="file" multiple [id]="elementId" [name]="elementId" [accept]="accept" />
      }
      <mat-icon class="text-secondary" style="cursor: pointer; font-size: 24px" svgIcon="file-plus-outline" />
      <div style="padding-top: 6px" class="text">
        @if (!fileText) {
          <span
            >Datei
            @if (multiple) {
              <span>en</span>
            }
          </span>
        }
        @if (fileText) {
          <span>{{ fileText }}</span>
        }
        auswählen/ablegen...
        @if (maxFilesize && !disableFilesizeHint) {
          <span> (max. {{ maxFilesize | mngFileSize }})</span>
        }
      </div>
      @if (supportedFilesText) {
        <div style="font-size: smaller" class="text-secondary">{{ supportedFilesText }}</div>
      }
    </div>
  </div>
</mng-file-drop>
